import request from "@/utils/request";
import { baseUrl } from "@/utils/config";

//年级数据
export function Grade(data) {
  return request({
    url: baseUrl + "/xx/getGrade",
    method: "get",
    params: data,
  });
}

//根据年级获取编辑数据
export function Class(data) {
  return request({
    url: baseUrl + "/xx/getClass",
    method: "get",
    params: data,
  });
}

//获取运动模式
export function trains(data) {
  return request({
    url: baseUrl + "/enum/train",
    method: "get",
    params: data,
  });
}
//获取运动类型
export function yundongtype(data) {
  return request({
    url: baseUrl + "/enum/type",
    method: "get",
    params: data,
  });
}
//获取运动模式
export function modes(data) {
  return request({
    url: baseUrl + "/enum/mode",
    method: "get",
    params: data,
  });
}
//获取作业列表
export function homeworklists(data) {
  return request({
    url: baseUrl + "/xx/homework",
    method: "get",
    params: data,
  });
}

//作业详情列表
export function readHomeWorks(data) {
  return request({
    url: baseUrl + "/xx/readHomeWork/" + data,
    method: "get",
    data,
  });
}
// /api/xx/readStudentHomeWork/{studen_id}/{work_id}
//获取学生作业详情
export function StudentHomeWorks(data) {
  return request({
    url: baseUrl + "/xx/readStudentHomeWork/" + data,
    method: "get",
    data,
  });
}
//根据id删除作业
export function deletejob(data) {
  return request({
    url: baseUrl + "/xx/deleteHomeWord/" + data,
    method: "get",
    data,
  });
}

//获取作业是否有学生完成/api/xx/prediction/{id}
export function predictions(data) {
  return request({
    url: baseUrl + "/xx/prediction/" + data,
    method: "get",
    data,
  });
}

// 系统日志

export function logrest(data) {
  return request({
    url: baseUrl + "log/rest",
    method: "get",
    params: data,
  });
}
